import { render, staticRenderFns } from "./BusinessDashboardLeads.vue?vue&type=template&id=ce620e96&scoped=true&"
import script from "./BusinessDashboardLeads.vue?vue&type=script&lang=js&"
export * from "./BusinessDashboardLeads.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDashboardLeads.vue?vue&type=style&index=0&id=ce620e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce620e96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VBtnToggle,VChip,VCol,VDivider,VIcon,VRow,VSheet})
